const styles = () => {
  return ({
    button: {
      width: '40px',
      height: '40px',
      position: 'fixed',
      bottom: '95px',
      right: '30px',
      borderRadius: '100%',
      background: '#F7F7FA',
      zIndex: 1000,
      transition: 'background-color .3s, opacity .5s, visibility .5s',
      opacity: 0,
      visibility: 'hidden',

      '&:hover': {
        cursor: 'pointer',
      },
    },

    showButton: {
      opacity: 1,
      visibility: 'visible',
    },

    backIcon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  })
}

export default styles
